// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import type { GridsCheckType } from '../../types';

const ReadOnly = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-align: center;
  margin: 0;
  border-radius: 50%;
  border: solid 1px
    ${({ $isChecked, $isCheckedButNoBase, theme }) => {
      if ($isChecked) {
        return theme.grids.colors.darkgrey2;
      }
      if ($isCheckedButNoBase) {
        return theme.grids.colors.grey;
      }
      return theme.grids.colors.lightgrey;
    }};
  width: 2em;
  height: 2em;
  min-width: 2em;
  min-height: 2em;
  padding: 0;
  background: ${({ $isChecked, theme }) => {
    if ($isChecked) {
      return theme.grids.colors.darkgrey2;
    }
    return 'transparent';
  }};
`;

const Label = styled.span`
  display: inline-block;
  font-family: BettingPoliticaExtraBold, sans-serif;
  font-size: 1em;
  line-height: 1;
  color: ${({ $isChecked, $isCheckedButNoBase, theme }) => {
    if ($isChecked) {
      return '#fff';
    }
    if ($isCheckedButNoBase) {
      return theme.grids.colors.grey;
    }
    return theme.grids.colors.lightgrey;
  }};
`;

type Props = {
  isChecked: boolean;
  isCheckedButNoBase: boolean;
  typeCheck: GridsCheckType;
  className?: string;
};

const CheckBoxBasket = ({ isChecked, isCheckedButNoBase, typeCheck, className }: Props) => {
  return (
    <ReadOnly
      className={className}
      $isChecked={isChecked}
      $isCheckedButNoBase={isCheckedButNoBase}
      data-testid="grid-check-basket"
    >
      <Label $isChecked={isChecked} $isCheckedButNoBase={isCheckedButNoBase}>
        {typeCheck}
      </Label>
    </ReadOnly>
  );
};

export default CheckBoxBasket;
